import { html, render } from 'lit-html';
import CtvLitElementBase from './element-base'
import "./dialog-base.scss";
import Utilities from "@camtv/front-base-lib/utilities/utilities"
import CtvLoadWaiter from './load-waiter'


let CtvDialogBase_DialogsStack = [ ];

export default class CtvDialogBase extends CtvLitElementBase {

	get MODAL_RESULT() {
		return {
			OK: "OK",
			CANCEL: "CANCEL",
			YES: "YES",
			NO: "NO",
		}
	}

	constructor() {
		super();

		this.UUID = CtvDialogBase.GenerateModalUUID();

		this.show_promise = null;
		this.show_promise_resolve = null;

		this.ModalResult = this.MODAL_RESULT.CANCEL;
		this.IsClosing = false;
		this.classModifier = "";

		this.waiter = null;
	}

	render() {
		return html`
            <div class="ctv-dialog-shadow ${this.classModifier}">
                <div class="ctv-dialog-wrapper">
                    <div class="ctv-dialog-close" @click="${this.OnClose}">${this.RenderClose()}</div>
                    <div class="ctv-dialog-header">${this.RenderHeader()}</div>
                    <div class="ctv-dialog-body">${this.RenderBody()}</div>
                    <div class="ctv-dialog-footer">${this.RenderFooter()}</div>
                </div>                
            </div>
        `;
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);

		CtvDialogBase.PushModalLayer(this);

		setTimeout(async ()=>{ await  this.Init() },1);
	}

	disconnectedCallback() {
		super.disconnectedCallback();

		setTimeout(async ()=>{ await  this.UnInit() },1);
	}

	RenderObject(Obj, DomElParent) {
		let t = typeof(Obj);
		if (Obj == null || Obj == "")
			DomElParent.innerHTML = "";
		else if ( typeof(Obj) == "string") {
			DomElParent.innerHTML = Obj;
		}
		else if (t == "object" && Obj.type=="html" && Obj.getHTML!=null)
			render(Obj,DomElParent)
		else {
			DomElParent.innerHTML = "";
			DomElParent.append(Obj);
		}
	}

	async Init() {

	}

	async UnInit() {

	}

	/**
	 * Close the dialog bringing the browser history back and removing the popstate event handles
	 * @method
	 */
	ReturnModalResult(Result) {
		setTimeout(()=> { this.Close(); },5);
		this.ModalResult = Result;
	}

	async Ok() {
		this.ReturnModalResult(this.MODAL_RESULT.OK);
	}

	async Cancel() {
		this.ReturnModalResult(this.MODAL_RESULT.CANCEL);
	}

	Close() {
		CtvDialogBase.PopAllDialogHistory(this)
	}

	async CanClose() {
		return true;
	}

	async OnClose(evt) {
		
		if (await this.CanClose() != true)
			return;

		this.Close();
	}	

	/**
	 * Overwrites the html of the close button
	 * @method
	 */
	RenderClose() {
		return html`<svg style="width:24px;height:24px" viewBox="0 0 24 24">
						<path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
					</svg>`;
	}

	/**
	 * Overwrites the html of the dialog header
	 * @method
	 */
	RenderHeader() {
		return html``;
	}

	/**
	 * Overwrites the html of the dialog body
	 * @method
	 */
	RenderBody() {
		return html``;
	}

	/**
	 * Overwrites the html of the dialog footer
	 * @method
	 */
	RenderFooter() {
		return html``;
	}

	async Wizard_Initialize(FastForwardToPageNumber) {
		if (FastForwardToPageNumber == null)
			FastForwardToPageNumber = 0

		this.WizardPaged = true
		this.Wizard_CurrentPage = 0
		await CtvDialogBase.PushModalLayerWizardPage(this, this.Wizard_CurrentPage, FastForwardToPageNumber!=0);	

		for (let i=1;i<=FastForwardToPageNumber;i++) {
			this.Wizard_CurrentPage++;
			await CtvDialogBase.PushModalLayerWizardPage(this, this.Wizard_CurrentPage, FastForwardToPageNumber!=i);
		}
	}

	async Wizard_PageNext() {
		this.WizardPaged = true;
		this.Wizard_CurrentPage++;
		await CtvDialogBase.PushModalLayerWizardPage(this,this.Wizard_CurrentPage);
	}

	Wizard_PagePrec() {
		this.WizardPaged = true;
		this.Wizard_CurrentPage--;
		setTimeout(()=> {
			window.history.replaceState(null, null);
			window.history.back();
		},1);
	}

	async Wizard_OnPageShow(PageNumber) {

	}

	ShowWaiter(Text,DelayBeforeShow) {
		this.HideWaiter();
		this.waiter = CtvLoadWaiter.Show(this.querySelector(".ctv-dialog-wrapper"),Text,DelayBeforeShow)
		this.waiter.show_top_right_hider = true;
		return this.waiter;
	}

	HideWaiter() {
		if (this.waiter != null)
			this.waiter.remove();		
		this.waiter  = null;
	}

	/**
	 * Show the dialog
	 * @method
	 * @param {Object} elDlg - The dialog element, if null it will be created a new one
	 */
	static Show(elDlg) {
		if (elDlg == null) {
			elDlg = document.createElement(this.DomTag);
		}

		elDlg.show_promise = new Promise((resolve)=> {
			elDlg.show_promise_resolve = resolve;
			document.body.append(elDlg);
		})

		return elDlg.show_promise;
	}

	static GenerateModalUUID() { return "CTVDialog#"+Utilities.GetRandomString(20); }

	static get FirstModalMarker() { return "CTVDialog#FIRS_ENTRY"; }

	static get DialogsStack() {
		return CtvDialogBase_DialogsStack;
	}

	static PushModalLayer(elDialog) {
		if (CtvDialogBase.DialogsStack.length == 0)
			window.history.pushState(CtvDialogBase.FirstModalMarker,null);

		window.history.pushState({ UUID: elDialog.UUID } ,null);

		CtvDialogBase.DialogsStack.push( { UUID: elDialog.UUID, elDialog: elDialog } );
	}

	static PopAllDialogHistory(elDlg) {
		// percorre indietro fino al primo CTVDialog#FIRS_ENTRY
		elDlg.IsClosing = true;
		window.history.replaceState(null, null);
		window.history.back();
	}

	static async PushModalLayerWizardPage(elDialog, PageNumber, DoNotCallOnPageShow) {
		if (CtvDialogBase.DialogsStack.length == 0)
			window.history.pushState(CtvDialogBase.FirstModalMarker,null);

		if (PageNumber == 0) {
			window.history.replaceState({UUID: elDialog.UUID + "_" + PageNumber}, null);
			CtvDialogBase.DialogsStack[CtvDialogBase.DialogsStack.length-1] = {
				UUID: elDialog.UUID + "_" + PageNumber,
				elDialog: elDialog,
				WizardPageNumber: PageNumber
			};
		} else {
			window.history.pushState({UUID: elDialog.UUID + "_" + PageNumber}, null);
			CtvDialogBase.DialogsStack.push({
				UUID: elDialog.UUID + "_" + PageNumber,
				elDialog: elDialog,
				WizardPageNumber: PageNumber
			});
		}

		try {
			if (DoNotCallOnPageShow != true)
				await elDialog.Wizard_OnPageShow(PageNumber);
		}catch { }
	}

	static async PopModalLayer(LayerData) {

		if (CtvDialogBase.DialogsStack.length == 0) {
			return;
		}

		if (LayerData!=null && LayerData.UUID!=null) {
			let i=0;
			for(;i<CtvDialogBase.DialogsStack.length;i++) {
				if (CtvDialogBase.DialogsStack[i].UUID == LayerData.UUID) {
					let dlg = CtvDialogBase.DialogsStack[i].elDialog;
					if (dlg!=null && dlg.IsClosing == true) {
						window.history.replaceState(null, null);
						window.history.back();
					} else {
						let WizardPageNumber = CtvDialogBase.DialogsStack[i].WizardPageNumber;
						if (dlg != null) {
							if (WizardPageNumber != null) {
								try {
									dlg.Wizard_CurrentPage = Types.ToInt(WizardPageNumber, 0);
									await dlg.Wizard_OnPageShow(dlg.Wizard_CurrentPage);
								} catch {
								}
							}
						}
					}
					break;
				}
			}

			for(let n=CtvDialogBase.DialogsStack.length-1;n>i;n--) {
				let dlg = CtvDialogBase.DialogsStack[n].elDialog;
				let WizardPageNumber = CtvDialogBase.DialogsStack[n].WizardPageNumber;
				if (dlg!=null && WizardPageNumber==null) {
					dlg.remove();
					dlg.show_promise_resolve(dlg.ModalResult);
				}
				CtvDialogBase.DialogsStack.splice(-1, 1);
			}
		}
		else {
			if (LayerData === CtvDialogBase.FirstModalMarker) {
				try {					
					let dlg = CtvDialogBase.DialogsStack[0].elDialog;
					if (CtvDialogBase.DialogsStack.length > 1)
						dlg = CtvDialogBase.DialogsStack[CtvDialogBase.DialogsStack.length - 1].elDialog;
					if (dlg != null) {
						
						if (dlg.CanClose!=null && dlg.IsClosing==false)  {
							//window.history.pushState(CtvDialogBase.FirstModalMarker,null);
							if (await dlg.CanClose() != true) {
								//window.history.replaceState(CtvDialogBase.FirstModalMarker,null);
								return;
							}
						}
						dlg.remove()
						dlg.show_promise_resolve(dlg.ModalResult);
					}
					CtvDialogBase.DialogsStack.splice(-1, 1);
					//if (CtvDialogBase.DialogsStack.length > 0)
					//	throw "Dialog Navigation Error"
				}
				catch (Ex) {
					console.error(Ex)
					CtvDialogBase.DialogsStack.splice(0,CtvDialogBase.DialogsStack.length)
				}
				if (CtvDialogBase.DialogsStack.length == 0) {
					window.history.replaceState(null, null);
					window.history.back();
				}
			}
		}
	}

	static async OnPopStateHandler (evt) {
		await CtvDialogBase.PopModalLayer(evt.state);
	}
}

window.addEventListener("popstate",CtvDialogBase.OnPopStateHandler);